import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import {Elements} from 'react-stripe-elements';
import {CardElement, injectStripe} from 'react-stripe-elements';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    // marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      // marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = ['Shipping address', 'Payment details', 'Review your order'];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <AddressForm />;
    case 1:
      return <PaymentForm />;
    case 2:
      return <Review />;
    default:
      throw new Error('Unknown step');
  }
}

class Checkout extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      company: "",
      address_line1: "",
      address_zip: "",
      address_city: "",
      address_country:"",
      email:"",
      activeStep: 0,
    }
    // this.handleTextField = this.handleTextField.bind(this);
    this.nextStep = this.nextStep.bind(this);
  }
  

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.props.back()

    // this.setState(state => ({
    //   activeStep: state.activeStep - 1,
    // }));


  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  nextStep(data){
    this.props.nextStep(data)
  }

  render() {
    const { classes } = this.props;
    const { activeStep } = this.state;

    return (
    
      <React.Fragment>
        <CssBaseline />
        
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            
            <React.Fragment>
              {this.props.step === 'form' ? (
                <React.Fragment>
                    
                 <AddressForm back={this.handleBack} nextStep={this.nextStep}/>
                </React.Fragment>
              ) : (
                <React.Fragment>

                
                  
                 <Review period={this.props.period} stripeToken={this.props.stripeToken} data={this.props.data} amount={this.props.amount} services={this.props.services}/>
                 
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
      
    );
  }
}

Checkout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(Checkout));
